import { useState, useEffect } from 'react';
import { css, Flex, Icon, SystemProps } from '@storyofams/react-ui';
import { pick } from '@styled-system/props';
import { startsWith } from 'lodash';

import { Button, Heading } from '~components';
import { useShopify } from '~context';
import { CheckoutFragmentFragment } from '~lib/shopify/sdk';
import { Minus, Plus } from '../Icons';

const StyledButton = ({ type = 'minus', outline, ...props }) => (
  <Button
    variant="unstyled"
    display="flex"
    alignItems="center"
    justifyContent="center"
    p={0}
    border="1px solid"
    borderColor={outline ? '#21857F' : '#69A8A2'}
    bg={outline ? 'transparent' : '#69A8A2'}
    borderRadius="4px"
    css={css({
      '&:active': {
        borderColor: 'grey700',
        color: 'grey700',
      },
    })}
    {...props}
  >
    <Icon icon={type === 'plus' ? Plus : Minus} color={outline ? '#69A8A2' : '#FFFFFF'} fontSize={3} />
  </Button>
);

export const StaticQuantityInput = ({
  small,
  outline,
  updateStaticAmount,
  ...props
}: Partial<CheckoutFragmentFragment['lineItems']['edges'][number]['node']> & {
  small?: boolean;
  outline?: boolean;
} & {updateStaticAmount?: (value: number) => void;
} & SystemProps) => {
  const [quantity, setQuantity] = useState(props?.quantity);

  const {
    adjustLineItemQuantity,
    addItemToCart,
    updatingCart,
    quantity: totalQuantity,
  } = useShopify();

  useEffect(() => {
    setQuantity(props.quantity);
  }, [props.quantity]);

  const updateQuantity = (amount) => {
    if (amount > 3 || amount < 0) return;
    setQuantity(amount);
    updateStaticAmount(amount);
    /* adjustLineItemQuantity({
      variantId: props.variant.id,
      quantity: amount,
    }); */
  };

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      cursor={updatingCart ? 'wait !important' : undefined}
      px={1}
      mx="auto"
      maxWidth={180}
      gap={1}
      {...pick(props)}
    >
      <StyledButton
        outline={outline}
        width={small ? 32 : [32, 45]}
        height={small ? 32 : [32, 45]}
        disabled={quantity <= 0}
        onClick={() => updateQuantity(quantity - 1)}
        cursor={updatingCart ? 'wait!important' : undefined}
      />

      <Heading
        as="h4"
        variant="sh4"
        width={40}
        textAlign="center"
      >
        {quantity}
      </Heading>

      <StyledButton
        outline={outline}
        type="plus"
        width={small ? 32 : [32, 45]}
        height={small ? 32 : [32, 45]}
        disabled={
          quantity >= 3
        }
        onClick={() => {
          updateQuantity(quantity + 1);
        }}
        cursor={updatingCart ? 'wait!important' : undefined}
      />
    </Flex>
  );
};
